// app/shared/components/loading-indicator/loading-indicator.component.ts
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../../../state/app.state';
import { selectIsLoading } from '../../../state/selectors/loading.selectors';
import { ProgressBarModule } from 'primeng/progressbar';

@Component({
    selector: 'app-loading-indicator',
    imports: [
        ProgressBarModule,
        CommonModule
    ],
    templateUrl: './loading-indicator.component.html',
    styleUrl: './loading-indicator.component.scss'
})
export class LoadingIndicatorComponent {
  isLoading$: Observable<boolean>;

  constructor(private store: Store<AppState>) {
    this.isLoading$ = this.store.select(selectIsLoading);
  }
}
